import http from '@/http'
import createCrudModule from 'vuex-crud'
import { withDataFilter } from '@/store/index'

const store = createCrudModule({
  client: http,
  resource: 'development/cities',
  urlRoot: 'development/cities',
})

export default withDataFilter(store)
